


<h1>Angular Router App</h1>
<!-- This nav gives you links to click, which tells the router which route to use (defined in the routes constant in  AppRoutingModule) -->
<nav>
  <ul>
    <li><a routerLink="/" routerLinkActive="active">Basic Page Component</a></li>
    <li><a routerLink="/dashboard" routerLinkActive="active">Dashboard Component</a></li>
    <li><a routerLink="/test-dashboard" routerLinkActive="active">Test Dashboard Component</a></li>
    <li><a routerLink="/eduSys-create" routerLinkActive="active">Education System Create Component</a></li>
    <li><a routerLink="/login" routerLinkActive="active">Login Page Component</a></li>
    <li><a routerLink="/changePassword" routerLinkActive="active">Change Password Page Component</a></li>
    <li><a routerLink="/header" routerLinkActive="active">Header Component</a></li>
    <li><a routerLink="/footer" routerLinkActive="active">Footer Component</a></li>
    <li><a routerLink="/r-home" routerLinkActive="active">Redirect Home Component</a></li>
    <li><a routerLink="/video-player" routerLinkActive="active">Play Video Component</a></li>
  </ul>
</nav>


<button mat-button [mat-menu-trigger-for]="menu" fxHide="false"
	fxHide.gt-sm>
	<mat-icon>menu</mat-icon>
</button>

<mat-menu x-position="before" #menu="matMenu">
<button mat-menu-item routerLink="/eduSys-create">
	<mat-icon>create_new_folder</mat-icon>
	Create Education System
</button>

<button mat-menu-item routerLink="/game">
	<mat-icon>gamepad</mat-icon>
	Play
</button>
</mat-menu>













<app-menu-top></app-menu-top>
<button mat-button [mat-menu-trigger-for]="menu" fxHide="false"
	fxHide.gt-sm>
	<mat-icon>menu</mat-icon>
</button>

<mat-menu x-position="before" #menu="matMenu">
<button mat-menu-item routerLink="/eduSys-create">
	<mat-icon>create_new_folder</mat-icon>
	Create Education System
</button>

<button mat-menu-item routerLink="/game">
	<mat-icon>gamepad</mat-icon>
	Play
</button>
</mat-menu>


<mat-grid-list cols="2" rowHeight="3:1">
<mat-grid-tile>Active User Count : {{activeUserCount}}</mat-grid-tile>
<mat-grid-tile>
	&nbsp;
	<mat-form-field class="full-width-input spacing-field">
		<!--<mat-label>Inherited calendar color</mat-label>-->
		<input matInput [matDatepicker]="picker1" placeholder="Choose a Date" formControlName="expiryDate"
			(dateInput)="addEvent('input', $event)" (dateChange)="addEvent('change', $event)"
			[min]="minDateFilter" [max]="maxDateFilter" [matDatepickerFilter]="customDateFilter" required>
		<mat-hint>MM/DD/YYYY</mat-hint>
		<mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
		<mat-datepicker [dateClass]="dateClass" #picker1 ></mat-datepicker>
	</mat-form-field>
	&nbsp;
	<mat-form-field class="example-full-width">
		<mat-label>Date from Popup</mat-label>
		<input matInput [matDatepicker]="picker2">
		<mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
		<mat-datepicker touchUi #picker2 color="primary"></mat-datepicker>
	</mat-form-field>
  </mat-grid-tile>
  <mat-grid-tile>
	  
	  <!--
	  https://css-tricks.com/how-to-add-text-in-borders-using-basic-html-elements/
	  -->
	  <fieldset>
		  <legend>Snake Bars FieldSet</legend> 
			<mat-card>
			<button mat-button (click)="openSnackBar('Hello', 'Close', 'blue-snackbar')">Primary</button>
		    <button mat-button (click)="notificationService.openSnackBar('Data Updated Successfully. Your password is 787878787878', 'Close', 'green-snackbar', 0)">Primary N</button>
		
			<button mat-button (click)="notificationService.error('error')">Error</button>
		
		  <button mat-button (click)="notificationService.success('success')">Success</button>
		
		  <button mat-button (click)="showConfirm()">Confirm</button>
		   <button mat-button (click)="showConfirmation()">Confirmirmation</button>
		  <button mat-button (click)="showConfirmCustom()">Confirm Custom</button>
		
		  <button mat-button (click)="showAlert()">Alert</button>
		</mat-card>
		</fieldset>
	</mat-grid-tile>
  <mat-grid-tile>
  <mat-slide-toggle>Toggle me!</mat-slide-toggle>
  </mat-grid-tile>
  
  
   <mat-grid-tile>
  <img src="/assets/img/study/online class kids.webp"  class="md-card-image" alt="Image">
  </mat-grid-tile>
  <mat-grid-tile><img src="/assets/img/study/online-classes-grp.jpg"  class="md-card-image" alt="Image"></mat-grid-tile>
  <mat-grid-tile><img src="/assets/img/study/online-classes-Engnr.jpg"  class="md-card-image" alt="Image"></mat-grid-tile>
  <!-- <mat-grid-tile><img src="/assets/img/study/online-classes-img.jpg" style="height:130px ; width:180px" class="md-card-image" alt="Image"></mat-grid-tile> -->
  <mat-grid-tile><img src="/assets/img/study/online-classes-img.jpg" class="md-card-image" alt="Image"></mat-grid-tile>
</mat-grid-list>

<mat-card>
  <mat-card-content>
		<div class="container1">
			<div slickContainer #slickController="slick" [slickConfig]="config">
			  <ng-container *ngIf="slickController.initialize">
			  <img slickItem *ngFor="let item of getSlickArray(slickArrayLength); let index = index" 
			  		src="{{item}}" class="p-10 md-card-image img-box1"> In Container
			  </ng-container>
			  out container
			</div>
			out div
			<button (click)="slickArrayLength = slickArrayLength - 1">-</button>
			{{ slickArrayLength }}
			<button (click)="slickArrayLength = slickArrayLength + 1">+</button>
			
			<button (click)="slickController.next()">Next</button>
			<button (click)="slickController.prev()">Previous</button>
			<button (click)="slickController.goTo(4)">Go to 4</button>
			<button (click)="slickController.play()">Play</button>
			<button (click)="slickController.pause()">Pause</button>
			<button (click)="slickController.unslick()" [disabled]="!slickController.initialize">Destroy</button>
			<button (click)="slickController.initSlick()" [disabled]="slickController.initialize">Init</button>
		</div>
		<!--<pre>
		  config: {{ config | json}}
		</pre>
		-->
  </mat-card-content>
</mat-card>



<div class="col-md-12">
	<table class="table table-responsive table-hover">
		<tr>
			<th>User Id</th>
			<th>Name</th>
			<th>Sub Name</th>
			<th>Nick Name</th>
			<th>Registration No</th>
			<th>Status</th>
			<th>&nbsp;</th>
		</tr>
		<tr *ngFor="let item of records">
			<td>{{item.owner!==null?item.owner.loginUserId:''}}</td>
			<td>{{item.name}}</td>
			<td>{{item.subName}}</td>
			<td>{{item.nickName}}</td>
			<td>{{item.registrationNo}}</td>
			<td>{{item.status}}</td>
			<td><a [routerLink]="['/eduSys-create',{'id':item.id}]">
				<button mat-button>
					<mat-icon>edit</mat-icon>
				</button>
				</a>
			</td>
			<td>
				<button mat-button (click)="deleteEducationSystem(item.id)">
					<mat-icon>delete_forever</mat-icon>
				</button>
				<a [routerLink]="['/eduSys-delete',item.id]">
				<button >
					<mat-icon>delete_forever</mat-icon>
				</button>
				</a>
			</td>
		</tr>
	</table>
</div>